export const DataBlock = (image, title, value, extraMargin = false) => {
  const margin = extraMargin ? `arrow-icon` : ''
  return (
    <div className="data-block">
      <img
        src={image}
        className={`block-image ${margin}`}
        alt={`${title}-fee-icon`}
      />
      <div className="right-block">
        <h2>{title}</h2>
        <h4>{value} Mina</h4>
      </div>
    </div>
  );
}
